<template>
	<vs-prompt
		:active.sync="activeProp"
		:buttons-hidden="true"
		:title="$t('assignManagerToOrder')"
		color="warning"
		class="assign-manager-required-popup"
		@cancel="keepOpen"
		@close="keepOpen"
	>
		<div class="con-exemple-prompt">
			<div class="mt-2">
				<label class="vs-input--label">{{ $t('manager') }}</label>
				<v-select
					v-model="selectedManagerId"
					:reduce="item => item.id"
					:options="managerOptions"
					:placeholder="$t('manager')"
					label="full_name"
					:clearable="false"
					class="single-row-select w-full"
				/>
			</div>

			<div class="flex justify-end mt-8">
				<vs-button
					color="warning"
					:disabled="!selectedManagerId || saving"
					@click="save"
				>
					{{ $t('save') }}
				</vs-button>
			</div>
		</div>
	</vs-prompt>
</template>

<script>
import vSelect from 'vue-select';

export default {
	name: "AssignManagerRequiredModal",
	components: {
		vSelect
	},
	props: {
		active: { default: false, type: Boolean },
		managers: { type: Array, default: () => [] },
	},
	data() {
		return {
			selectedManagerId: null,
			saving: false,
			allowClose: false,
		};
	},
	computed: {
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				if (!value && this.active && !this.allowClose) {
					this.$emit("update:active", true);
					return;
				}
				this.$emit("update:active", value);
			}
		},
		managerOptions() {
			return (this.managers || []).map((manager) => ({
				...manager,
				full_name: `${manager.first_name} ${manager.last_name}`.trim(),
			}));
		},
	},
	watch: {
		active(value) {
			if (value) {
				this.selectedManagerId = null;
				this.saving = false;
				this.allowClose = false;
			}
		},
	},
	methods: {
		keepOpen() {
			if (this.allowClose) return;
			this.$emit("update:active", true);
		},
		save() {
			if (!this.selectedManagerId || this.saving) return;
			this.$emit("save", this.selectedManagerId);
		},
		setSaving(value) {
			this.saving = !!value;
		},
		permitClose() {
			this.allowClose = true;
		},
	},
};
</script>

<style lang="scss">
.assign-manager-required-popup {
	&.con-vs-dialog {
		z-index: 54000;
	}
	.vs-dialog {
		max-width: 400px;
	}
}
</style>
